<template>
  <div class="header" id="header">
    <div class="container">
      <!-- 左側LOGO -->
      <div class="left-container" @click="link(index_url, false)">
        <BTrackingClickEvent
          event="comics_event_comic_music_global_item_click"
          eventId="8503"
          :pageInfo="{ tab: '' }"
          :clickInfo="{ sec: 'header', name: 'logo' }"
          @click.stop.prevent
        >
          <div class="logo_box">
            <img
              @click="link(index_url, false)"
              class="logo_img"
              src="/images/20231109/header/雙星logo_header.svg"
            />
          </div>
        </BTrackingClickEvent>
        <BTrackingClickEvent
          event="comics_event_comic_music_global_item_click"
          eventId="8503"
          :pageInfo="{ tab: '' }"
          :clickInfo="{ sec: 'header', name: 'logo' }"
          @click.stop.prevent
        >
          <div class="logo_box">
            <img
              @click="link(index_url, false)"
              class="music_logo"
              src="/images/20231109/header/music_logo.png"
            />
          </div>
        </BTrackingClickEvent>
        <!-- 漢堡線 -->
        <span class="menu" @click.stop.prevent="onClickMenu" v-if="isMobile">
          <img src="/images/anniversary2023/other/menu.svg" />
        </span>
      </div>
      <!-- 大網右側錨點 -->
      <div class="menu-container-desktop" v-if="!isMobile">
        <!-- @click="scrollToComponent('indexB02', 70)" -->
        <div class="mcd-anchor">
          <router-link :to="{ name: 'IndexAnchor', params: { anchor: 'works.html' } }">
            <BTrackingClickEvent
              event="comics_event_comic_music_global_item_click"
              eventId="8503"
              :pageInfo="{ tab: '' }"
              :clickInfo="{ sec: 'header', name: 'all' }"
            >
              <span class="anchor"> 音樂 x 漫畫 x 小說</span>
            </BTrackingClickEvent>
          </router-link>
        </div>
        <div class="mcd-anchor">
          <!-- @click="scrollToComponent('indexB03', 70)" -->
          <a href="https://bean.fun/nzxaS" target="_blank">
              <BTrackingClickEvent
                event="comics_event_comic_music_global_item_click"
                eventId="8503"
                :pageInfo="{ tab: '' }"
                :clickInfo="{ sec: 'header', name: 'activity' }"
              > 
              <span class="anchor">活動得獎名單</span>
              </BTrackingClickEvent>
            </a>
        </div>
        <div class="mcd-anchor">
          <!-- @click="scrollToComponent('indexB05', 70)" -->
          <router-link :to="{ name: 'IndexAnchor', params: { anchor: 'moreworks.html' } }">
            <BTrackingClickEvent
              event="comics_event_comic_music_global_item_click"
              eventId="8503"
              :pageInfo="{ tab: '' }"
              :clickInfo="{ sec: 'header', name: 'works' }"
            >
              <span class="anchor">更多作品</span>
            </BTrackingClickEvent>
          </router-link>
        </div>
        <div class="mcd-anchor">
          <!-- @click="scrollToComponent('indexB06', 250)" -->
          <router-link :to="{ name: 'IndexAnchor', params: { anchor: 'news.html' } }">
            <span class="anchor">
              <BTrackingClickEvent
                event="comics_event_comic_music_global_item_click"
                eventId="8503"
                :pageInfo="{ tab: '' }"
                :clickInfo="{ sec: 'header', name: 'news' }"
              >
                更多消息
              </BTrackingClickEvent>
            </span>
          </router-link>
        </div>
      </div>
      <!-- 小網錨點 -->
      <div class="menu-container-mobile" v-if="isShowMenu && isMobile">
        <div
          class="left-container"
          @click="link(index_url, false)"
          @click.stop.prevent="onClickMenu"
        >
          <BTrackingClickEvent
            event="comics_event_comic_music_global_item_click"
            eventId="8503"
            :pageInfo="{ tab: '' }"
            :clickInfo="{ sec: 'header', name: 'logo' }"
          >
            <div class="logo_box">
              <img
                @click="link(index_url, false)"
                @click.stop.prevent="onClickMenu"
                class="logo_img"
                src="/images/20231109/header/雙星logo_header.svg"
              />
            </div>
          </BTrackingClickEvent>
          <BTrackingClickEvent
            event="comics_event_comic_music_global_item_click"
            eventId="8503"
            :pageInfo="{ tab: '' }"
            :clickInfo="{ sec: 'header', name: 'logo' }"
          >
            <div class="logo_box">
              <img
                @click="link(index_url, false)"
                @click.stop.prevent="onClickMenu"
                class="music_logo"
                src="/images/20231109/header/music_logo.png"
              />
            </div>
          </BTrackingClickEvent>
          <div class="mcm-close" @click.stop.prevent="onClickMenu">
            <img
              class="mcm-close-img"
              src="/images/anniversary2023/icons/X.svg"
            />
          </div>
        </div>

        <div class="mcm-anchor">
          <router-link
            :to="{ name: 'IndexAnchor', params: { anchor: 'works.html' } }"
            @click.prevent="onClickMenu"
          >
            <span class="anchor">
              <BTrackingClickEvent
                event="comics_event_comic_music_global_item_click"
                eventId="8503"
                :pageInfo="{ tab: '' }"
                :clickInfo="{ sec: 'header', name: 'all' }"
              >
                音樂 x 漫畫 x 小說
              </BTrackingClickEvent>
            </span>
          </router-link>
        </div>
        <div class="mcm-anchor">
          <!-- <router-link
            :to="{ name: 'IndexAnchor', params: { anchor: 'mission.html' } }"
            @click.prevent="onClickMenu"
          > -->
          <a href="https://bean.fun/nzxaS" target="_blank">
            <span class="m-anchor">
              <BTrackingClickEvent
                event="comics_event_comic_music_global_item_click"
                eventId="8503"
                :pageInfo="{ tab: '' }"
                :clickInfo="{ sec: 'header', name: 'activity' }"
              >
                活動得獎名單
              </BTrackingClickEvent>
            </span>
            </a>
          <!-- </router-link> -->
        </div>
        <div class="mcm-anchor">
          <router-link
            :to="{ name: 'IndexAnchor', params: { anchor: 'moreworks.html' } }"
            @click.stop.prevent="onClickMenu"
          >
            <span class="m-anchor">
              <BTrackingClickEvent
                event="comics_event_comic_music_global_item_click"
                eventId="8503"
                :pageInfo="{ tab: '' }"
                :clickInfo="{ sec: 'header', name: 'works' }"
              >
                更多作品
              </BTrackingClickEvent>
            </span>
          </router-link>
        </div>
        <div class="mcm-anchor">
          <router-link
            :to="{
              name: 'IndexAnchor',
              params: {
                anchor: 'news',
              },
            }"
            @click.stop.prevent="onClickMenu"
          >
            <span class="m-anchor">
              <BTrackingClickEvent
                event="comics_event_comic_music_global_item_click"
                eventId="8503"
                :pageInfo="{ tab: '' }"
                :clickInfo="{ sec: 'header', name: 'news' }"
              >
                更多消息
              </BTrackingClickEvent>
            </span>
          </router-link>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
// import { useScrollTo } from "@vue/composition-api";
import * as login from "@/api/login";
import { loginUrl, openLink } from "@/lib/Utils";
import DeviceServices from "@/services/DeviceServices";
import { tr } from "element-plus/lib/locale/index.js";
import { emit } from "process";
import BTrackingClickEvent from "@/components/BTracking/BTrackingClickEvent.vue";
import {
  defineComponent,
  computed,
  watch /*, onMounted*/,
  ref,
  inject,
} from "vue";
import { useRoute } from "vue-router";

export default {
  name: "Header",
  components: {
    BTrackingClickEvent,
  },
  props: {
    prefix: String,
  },
  data() {
    return {
      comics_url: import.meta.env.VITE_COMICS_URL, // 漫畫星轉址
      novels_url: import.meta.env.VITE_NOVELS_URL, // 文學星轉址
      // nickName: "", // 會員名稱
      // showLogin: true, // 是否顯示登入的區塊
      // showLogout: false, // 是否顯示登出的區塊
      // nickNameImage: "/images/anniversary2023/icons/avatar_default.svg", // 預設頭貼
      index_url: import.meta.env.VITE_COMICS_URL + import.meta.env.VITE_BASE,
      // index_url: import.meta.env.VITE_BASE,
      // loginId: this.prefix + "login",
      // logoutId: this.prefix + "logout",
      // eventlogoId: this.prefix + "eventlogo",
      headerComicsId: this.prefix + "header_comics",
      headerNovelsId: this.prefix + "header_novels",
      isdebug: import.meta.env.VITE_DEBUG_MODE,
      ssrMode: import.meta.env.SSR,
      baseUrl: import.meta.env.VITE_BASE,
    };
  },
  mounted() {
    // const initialAnchor = this.$route.params.a;
    const initialAnchor = this.$route.params.anchor;
    const isMobile = ["iOS", "iPadOS", "AndroidOS", "WindowsPhoneOS"].includes(
      DeviceServices.getDevice()
    );
    localStorage.setItem("B06BannerFirst", "f");
    //  ******目前改為不滾動，直接跳到該錨點 ********
    if (initialAnchor) {
      this.$nextTick(() => {
        let targetElementId = ref("");
        let offset = ref(0);
        const currentPosition = ref(0);
        const appDiv = document.getElementById("app") as HTMLElement;
        var myTarget = appDiv.getAttribute("myTarget");
        const header = document.getElementById("header") as HTMLElement;
        switch (initialAnchor) {
          case "works.html":
            // targetElementId.value = "indexB02";
            // offset.value = isMobile ? 30 : 70; // 根据移动设备设置不同的偏移量
            var tarId = "indexB02";
            var indexEle = document.getElementById(tarId) as HTMLElement;
            if (null != indexEle && (null == myTarget || myTarget != tarId)) {
              targetElementId.value = tarId;
              offset.value = isMobile ? 42 : header.offsetHeight /*70*/;
              appDiv.setAttribute("myTarget", tarId);
            }
            break;
          case "mission.html":
            // targetElementId.value = "indexB03";
            // offset.value = isMobile ? 18 : 0;
            var tarId = "indexB03";
            var indexEle = document.getElementById(tarId) as HTMLElement;
            if (null != indexEle && (null == myTarget || myTarget != tarId)) {
              targetElementId.value = tarId;
              offset.value = isMobile ? 42 : header.offsetHeight /*70*/;
              appDiv.setAttribute("myTarget", tarId);
            }
            break;
          case "moreworks.html":
            var tarId = "indexB05";
            var indexEle = document.getElementById(tarId) as HTMLElement;
            if (null != indexEle && (null == myTarget || myTarget != tarId)) {
              targetElementId.value = tarId;
              offset.value = isMobile ? 42 : header.offsetHeight /*70*/;
              appDiv.setAttribute("myTarget", tarId);
            }
            break;
          case "news.html":
            // targetElementId.value = "indexB06";
            // offset.value = isMobile ? 100 : 250;
            var tarId = "indexB06";
            var indexEle = document.getElementById(tarId) as HTMLElement;
            if (null != indexEle && (null == myTarget || myTarget != tarId)) {
              targetElementId.value = tarId;
              offset.value = isMobile ? 100 : 250;
              appDiv.setAttribute("myTarget", tarId);
            }
            break;
          default:
            break;
        }
        if (null != targetElementId.value && targetElementId.value.length > 0) {
          const targetElement = document.getElementById(targetElementId.value);
          console.log(targetElement);

          if (targetElement) {
            window.requestAnimationFrame(() => {
              const yOffset =
                targetElement.getBoundingClientRect().top +
                window.scrollY -
                offset.value;

              // 更新当前滚动位置
              currentPosition.value = yOffset;
              var headerHeight = 0; //header.offsetHeight/2;
              window.scrollTo({
                top: yOffset + headerHeight,
                behavior: "auto",
              });
            });
          }
        }
      });
    }
  },
  methods: {
    // 開啟外部連結
    link(url: string, open: boolean) {
      openLink({ url: url, open: open });
    },
  },
  setup(props) {
    const route = useRoute();
    const isMobile = ["iOS", "iPadOS", "AndroidOS", "WindowsPhoneOS"].includes(
      DeviceServices.getDevice()
    );
    let isShowMenu = ref(false);

    const onClickMenu = (me: MouseEvent) => {
      //isShowDetailVideo.value = false; //!isShowDe
      var target = me.target as HTMLElement;
      const displayId = target.getAttribute("displayId") as string;
      //console.log("me:", displayId);
      isShowMenu.value = !isShowMenu.value;
    };
    let isAreaIn = ref(false);
    let isShowLogoutDropDown = ref(false);
    const currentScrollPosition = ref(0);
    const B06BannerFirst = ref(false);

    const scrollToComponent = (componentId, offset) => {
      // 根据组件ID滚动到相应的组件
      const componentElement = document.getElementById(componentId);
      if (componentElement) {
        const yOffset =
          componentElement.getBoundingClientRect().top +
          window.scrollY -
          offset;

        // 更新当前滚动位置
        currentScrollPosition.value = yOffset;
        window.scrollTo({ top: yOffset, behavior: "smooth" });
        console.log(currentScrollPosition.value);
        console.log(yOffset);
        console.log(offset);
      }
      if (componentId == "indexB06") {
        localStorage.setItem("B06BannerFirst", "t");
        setTimeout(() => {
          localStorage.setItem("B06BannerFirst", "f");
        }, 2000);
      }
    };
    const onDisappearPopup = () => {
      let interval = setInterval(() => {
        //console.log("isAreaIn.value:", isAreaIn.value);
        if (false == isAreaIn.value) {
          isShowLogoutDropDown.value = false;
          clearInterval(interval);
        }
      }, 8000);
    };
    watch(route, (value) => {
      // const anchor = value.params.a;
      const anchor = value.params.anchor;
      // console.log(anchor);
      if (anchor) {
        setTimeout(() => {
          switch (anchor) {
            case "works.html":
              scrollToComponent("indexB02", isMobile ? 42 : 70);
              break;
            case "mission.html":
              scrollToComponent("indexB03", isMobile ? 42 : 70);
              break;
            case "moreworks.html":
              scrollToComponent("indexB05", isMobile ? 42 : 70);
              break;
            case "news.html":
              scrollToComponent("indexB06", isMobile ? 100 : 250);
              break;
            default:
              break;
          }
        }, 200);
      }
    });
    return {
      onDisappearPopup,
      scrollToComponent,
      isAreaIn,
      isShowLogoutDropDown,
      onClickMenu,
      isShowMenu,
      isMobile,
    };
  },
};
</script>

<style scoped>
/* ---------- 大網 -------- */
.header {
  width: 100vw;
  text-align: left;
  position: fixed;
  z-index: 999;
  top: 0;
  background: #000000;
  /* background: linear-gradient(180deg, #000000 20.31%, rgba(10, 9, 9, 0) 100%); */
  height: 70px;
  max-height: 70px;
}
.header .container {
  width: 100%;
  padding: 0 4.7%;
  display: flex;
  flex-wrap: nowrap;
  justify-content: space-between;
  height: 100%;
}
.header .container .left-container {
  width: 320px;
  display: flex;
  cursor: pointer;
  margin-top: 19px;
}
/* 漢堡線 */
.header .container .left-container .menu {
  display: none;
}
.header .container .left-container .logo_img {
  max-width: 174.6px;
  width: 100%;
  display: inline-block;
  margin-right: 18.4px;
}
.header .container .left-container .logo_box .music_logo {
  max-width: 122.18px;
  width: 100%;
  display: inline-block;
  margin-right: 18.4px;
}
.header .container .menu-container-desktop {
  display: flex;
  align-items: center;
  font-size: 15px;
  font-weight: 400;
  height: 21.72px;
  margin-top: 24px;
}
/* 大網右側錨點 */
.menu-container-desktop .mcd-anchor {
  cursor: pointer;
}
.menu-container-desktop .mcd-anchor .anchor {
  font-weight: 400;
  font-size: 15px;
  line-height: 21.72px;
  width: 45px;
  margin-right: 40px;
}
span {
  color: #fff;
  /* margin-right: 20px; */
}
.header .container .menu-container-mobile {
  display: none;
}
/* ----------- 小網 ----------- */
@media screen and (max-width: 800px) {
  .header {
    height: 44px;
    max-height: 44px;
    background: #000000;
  }
  .header .container {
    width: 100%;
    padding: 7px 4px;
  }
  .header .container .left-container {
    margin-top: 0;
    /* align-items: center; */
  }
  /* 漢堡線 */
  .header .container .left-container .menu {
    display: inline-block;
    position: absolute;
    right: 10px;
    top: 12px;
    width: 20px;
    max-width: 20px;
    margin-right: 0;
  }
  .header .container .left-container .logo_img {
    max-width: 174.6px;
    width: 100%;
    margin-right: 9.4px;
  }
  .header .container .left-container .logo_box .music_logo {
    max-width: 81.45px;
    width: 100%;
    margin-top: 5px;
  }
  .header .container .menu-container-desktop {
    display: none;
  }
  .header .container .menu-container-mobile {
    display: block;
    align-items: center;
    font-size: 18px;
    position: fixed;
    top: 0;
    right: 0;
    height: 100vh;
    width: 100vw;
    background-color: black;
  }
  .header .container .menu-container-mobile .left-container {
    padding: 7px 4px;
  }
  .menu-container-mobile .mcm-close {
    position: absolute;
    right: 10px;
    top: 12px;
  }
  .menu-container-mobile .mcm-close .mcm-close-img {
    width: 20px;
    height: 20px;
  }
  .menu-container-mobile .mcm-anchor {
    width: 100%;
    padding: 17px 20px;
  }
  .menu-container-mobile .mcm-anchor .m-anchor {
    font-weight: 500;
    font-size: 14px;
    line-height: 20.27px;
    /* width: 45px; */
  }
}
</style>

<style>
.ivu-dropdown-rel {
  position: fixed !important;
  top: 10px;
  right: 5%;
}
.ivu-select-dropdown {
}
.ivu-dropdown-menu {
  position: absolute;

  /*如果螢幕寬度為 800px 以下，就套用 css 設定*/
  @media screen and (max-width: 800px) {
  }
  /*如果螢幕寬度為 800px 以上 ，就套用 css 設定*/
  @media screen and (min-width: 801px) {
    background-color: white;
    /* right: 5%; */
    width: 92px;
    height: 44px;
    /* top: 43.99999999999977px; */
    /* left: 1508px; */
    padding: 4px 12px 4px 12px;
    text-align: center;
    border-radius: 10px;

    font-family: Noto Sans TC;
    font-size: 14px;
    font-weight: 500;
    line-height: 20px;
    letter-spacing: 0em;
    text-align: cent;

    position: fixed !important;
    top: 48px;
    right: 5%;
  }
}
.dropdown-menu {
  position: absolute;

  /* 如果螢幕寬度為 800px 以下，就套用 css 設定 */
  /* @media screen and (max-width: 800px) {
  } */
  /*如果螢幕寬度為 800px 以上 ，就套用 css 設定*/
  @media screen and (min-width: 801px) {
    background-color: white;
    /* right: 5%; */
    width: 92px;
    height: 44px;
    /* top: 43.99999999999977px; */
    /* left: 1508px; */
    padding: 10px 12px 4px 12px;
    text-align: center;
    border-radius: 10px;

    font-family: Noto Sans TC;
    font-size: 14px;
    font-weight: 500;
    line-height: 20px;
    letter-spacing: 0em;
    text-align: cent;

    position: fixed !important;
    top: 48px;
    right: 5%;
  }
}
</style>
